import { P00039DataRxTxIndex } from '../../P00039Sync';
import { IProduct } from '../../../IProduct';
import { Pool } from '../../../../../../apis/pool.api';
import { getPoolMasterClass } from '../../../../ECoSystemsHelper';

export function P00080InstallationFinish(
  pool: Pool,
  productClass: IProduct,
  editValue: any,
) {
  const master = getPoolMasterClass(pool);
  const presence = master?.hasProduct(pool, productClass) ?? 0;

  editValue(
    P00039DataRxTxIndex.Altimeo_Installation,
    'alIConfigurationProduit',
    presence != 0,
    null,
    productClass,
  );
}
